import { render, staticRenderFns } from "./ApplyReturnOrderManage.vue?vue&type=template&id=143d606c&scoped=true"
import script from "./ApplyReturnOrderManage.vue?vue&type=script&lang=js"
export * from "./ApplyReturnOrderManage.vue?vue&type=script&lang=js"
import style0 from "./ApplyReturnOrderManage.vue?vue&type=style&index=0&id=143d606c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d606c",
  null
  
)

export default component.exports